import { type PreviousSaleState, type SellScreenActionTypes } from "../../Actions/SellScreen/SellScreenActions";
import {
    PREVIOUS_SALE_ADD_CUSTOMER,
    PREVIOUS_SALE_PRINTED,
    UPDATE_PREVIOUS_SALE,
} from "../../Actions/SellScreen/SellScreenConstants";
import { type ShopfrontActions } from "../../Utilities/Generic/ActionsHelper";

function SellScreenPreviousSaleReducer(
    state: PreviousSaleState,
    action: ShopfrontActions<SellScreenActionTypes>
): PreviousSaleState {
    if(typeof state === "undefined") {
        return false;
    }

    switch(action.type) {
        case UPDATE_PREVIOUS_SALE:
            return action.sale;
        case PREVIOUS_SALE_PRINTED:
            if(!state) {
                return false;
            }

            return {
                ...state,
                printReceipt: false,
            };
        case PREVIOUS_SALE_ADD_CUSTOMER:
            if(!state) {
                return false;
            }

            return {
                ...state,
                customer: {
                    ...action.customer,
                },
            };
    }

    return state;
}

export default SellScreenPreviousSaleReducer;
